module.exports = __webpack_public_path__ + "static/media/noun-coffee-2820266-142350.f66936dd.svg";